var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "xh-wrap"
  }, [_c('myImg', {
    attrs: {
      "img": "https://faststatic.ccnfgame.com/cos/vrshow/autoShow/banner_2_1.jpg"
    }
  }), _vm._v(" "), _c('myTab', {
    attrs: {
      "tab-list": _vm.tabList,
      "activeIndex": _vm.activeIndex,
      "bread-title": _vm.breadTitle,
      "smallSize": ""
    },
    on: {
      "change": _vm.changeTab
    }
  }), _vm._v(" "), (_vm.activeIndex == 0) ? [_c('div', {
    staticClass: "container text-center color-ccc fs-30 empty-tip "
  }, [_vm._v("\n      " + _vm._s(_vm.$t("public.comesoon")) + "\n    ")])] : _vm._e(), _vm._v(" "), (_vm.activeIndex == 1) ? [_c('div', {
    staticClass: "container text-center color-ccc  fs-30 empty-tip "
  }, [_vm._v("\n      " + _vm._s(_vm.$t("public.comesoon")) + "\n    ")])] : _vm._e(), _vm._v(" "), _c('page-footer')], 2)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ef5db37","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/activity/index.vue
// module id = null
// module chunks = 